"use client";

import { getAviPillarInitial } from "@/constants";
import { cn } from "@/lib/utils";

interface AviFilterPillarBadgeProps {
  pillar?: string | null;
  selected?: boolean;
  disabled?: boolean;
  className?: string;
}

export function AviFilterPillarBadge({
  pillar,
  selected = false,
  disabled = false,
  className,
}: AviFilterPillarBadgeProps) {
  return (
    <span
      className={cn(
        "flex size-7 shrink-0 items-center justify-center rounded-full bg-neutral-100 text-neutral-500 transition-colors",
        selected && "bg-[#349698] text-white",
        disabled && !selected && "bg-neutral-50 text-neutral-300",
        className
      )}
    >
      <span className="text-sm leading-none font-medium tracking-[-0.0125rem]">
        {getAviPillarInitial(pillar)}
      </span>
    </span>
  );
}
